import { AfterContentInit, Component, Input, OnInit, inject, input } from '@angular/core';
import { AltmetricService } from '../../../parts/altmetric/altmetric.service';
import { UsageData } from '../../../shared/interfaces/research-portal/full-asset-page/usage-data.Interface';
import { AssetPageService } from '../../asset-page.service';
import { Observable } from 'rxjs';
import { EsploroMetricSource } from '../../../shared/interfaces/esploro-metric-source';
import { TranslateModule } from '@ngx-translate/core';
import { SvgViewboxDirective } from '@exl-ng/mulo-core';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'esp-usage-metrics',
    templateUrl: './usage-metrics.component.html',
    styleUrls: ['./usage-metrics.component.scss'],
    imports: [
        MatIcon,
        SvgViewboxDirective,
        AsyncPipe,
        TranslateModule
    ]
})
export class UsageMetricsComponent implements OnInit, AfterContentInit {
    private altmetricService = inject(AltmetricService);
    private assetPageService = inject(AssetPageService);

    readonly mmsID = input<string>(undefined);
    // TODO: Skipped for migration because:
    //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
    //  and migrating would break narrowing currently.
    @Input() doi: string;
    readonly wosIdentifier = input<string>(undefined);
    readonly metrics = input([]);

    usageData: UsageData;
    wosCitationTotal = 0;
    scopusCitationTotal$: Observable<number>;

    displayUsage: boolean;
    displayAltmetrics: boolean;
    displayWOSCitation: boolean;
    displayScopusCitation: boolean;
    displayCitationSrcIcon = false;

    ngOnInit() {
        this.displayUsage = this.isMetricTypeActive('usage');
        this.displayAltmetrics = this.isMetricTypeActive('altmetrics');
        this.displayWOSCitation = this.isMetricTypeActive('wos');
        this.displayScopusCitation = this.isMetricTypeActive('scopus');

        if (this.displayUsage) {
            this.getUsageData();
        }
        if (this.displayWOSCitation) {
            this.getWOSCitationTotal();
        }
        this.scopusCitationTotal$ = this.assetPageService.getCitationTotal(
            this.mmsID(),
            EsploroMetricSource.Scopus,
        );
    }

    ngAfterContentInit() {
        this.loadAltmetricScript();
    }

    loadAltmetricScript() {
        setTimeout(() => {
            this.altmetricService.loadScript();
        }, 800);
    }

    isMetricTypeActive(type) {
        return this.metrics()?.filter((metric) => metric.code === type)[0]
            ?.active;
    }

    getUsageData() {
        this.assetPageService.getUsageData(this.mmsID()).subscribe((data) => {
            this.usageData = data as UsageData;
            if (this.usageData.views === 0) {
                this.usageData.views = 1;
            }
        });
    }

    getWOSCitationTotal() {
        this.assetPageService
            .getWOSCitationTotal(this.mmsID())
            .subscribe((data) => {
                this.wosCitationTotal = data as number;
            });
    }

    getLink() {
        return (
            'https://www.webofscience.com/wos/woscc/full-record/WOS:' +
            this.wosIdentifier().replace('WOS:', '')
        );
    }
}
